import React, { useEffect, useState } from 'react';
import { Form, notification, Spin } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useHistory } from 'react-router';
import DF from 'DisplayFramework';
import {
  createThirdParty,
  getThirdPartyAuthorizationListByTpid,
  getTPCurrentStatusByTpid,
  ThirdPartyRequest,
  ThirdPartyResponse,
  updateThirdParty,
  ViewEntityAddAttributeResponse,
} from '../../../../services/thirdParty';
import WizardTabs from 'components/WizardTabs';
import { useParams } from 'react-router-dom';
// import { onFinishFailed } from 'components/DisplayValidationErrors/DisplayValidationErrors';
import { dateToString, toDatePickerDate } from 'utils/utils2';
import { useQuery } from 'react-query';
import { getMyWizards } from 'services/workflow';
import { isNaN, isNil } from 'lodash';
import moment from 'moment';
import { useGetThirdPartyDetail } from '../../ThirdPartyDetail/useGetThirdPartyDetail';
import AddressCardSFS from './AddressesCard/AddressCardSFS';
import ContactCardSFS from './ContactCardSFS';
import GeneralDataSFS from './GeneralDataSFS';
import TabBkInfoSFS from './TabBkInfoSFS';
import TabPlafondsandGradingSFS from './PlafondsAndGrading/TabPlafondsandGradingSFS';
import AccordSFS from './AccordSFS';

export type ThirdPartyDetailSFSProps = {
  tpId?: string;
  phase?: 'LEAD' | 'TP';
  taskid?: number;
  isProposalCreate?: boolean;
  iscreate?: boolean;
  onSelect?: (item: ThirdPartyResponse) => void;
  isModal?: boolean;
};

const ThirdPartyDetailSFS = (props: ThirdPartyDetailSFSProps) => {
  let { id, phase } = useParams<{ id: string; phase: 'LEAD' | 'TP' }>();
  const { taskid, onSelect, isModal } = props;
  const [tptype, settptype] = useState<string>('');

  const getId = () => {
    return props.tpId ? (props.tpId === '0' ? undefined : props.tpId) : id;
  };
  const getPhase = () => {
    return props.phase ? props.phase : phase;
  };
  id = getId() as any;
  phase = getPhase();
  const [form] = useForm();
  const history = useHistory();

  const { data, refetch, isFetching } = useGetThirdPartyDetail(
    isNaN(Number(id)) ? undefined : Number(id),
    phase
  );

  const { data: wizData } = useQuery(['getMyWizards', 'THIRDPARTY'], () =>
    getMyWizards({ entity: 'THIRDPARTY' }).then((res) => res.data)
  );

  const [loadingBtn, setLoadingBtn] = useState(false);
  var thirdParty = data;

  useEffect(() => {
    if (thirdParty) {
      settptype(thirdParty?.generalData?.tptype);
      form.setFieldsValue({
        tpclass: thirdParty?.generalData?.tpclass,
        tpclasslabel: thirdParty?.generalData?.tpclasslabel,
        tpclassdate: thirdParty?.generalData?.tpclassdate,
        tprevenue: thirdParty?.generalData?.tprevenue,
        tprevenuereferenceyear: toDatePickerDate(
          thirdParty?.generalData?.tprevenuereferenceyear
        ),
        tpidentitycardcountry: thirdParty?.generalData?.tpidentitycardcountry,
        tpidentitycardexpirationdate: toDatePickerDate(
          thirdParty?.generalData?.tpidentitycardexpirationdate
        ),
        tpactivitysector: thirdParty?.generalData?.tpactivitysector,
        tpflagresident: thirdParty?.generalData?.tpflagresident,
        tpcategory: thirdParty?.generalData?.tpcategory,
        tpcompanysize: thirdParty?.generalData?.tpcompanysize,
        tpparentcompanyid: thirdParty?.additionalInfo?.tpparentcompanyid,
        tpparentcompanyname: thirdParty?.generalData?.tpparentcompanyname,
        tpfree1: thirdParty?.additionalInfo?.tpfree1,
        tpfree2: thirdParty?.additionalInfo?.tpfree2,
        tpfree3: thirdParty?.additionalInfo?.tpfree3,
        tpfree4: thirdParty?.additionalInfo?.tpfree4,
        tpfree5: thirdParty?.additionalInfo?.tpfree5,
        tpdescription: thirdParty?.additionalInfo?.tpdescription,
        tpid: thirdParty?.generalData?.tpid,
        currcode: thirdParty?.generalData?.currcode,
        tpreference: thirdParty?.generalData?.tpreference,
        tptype: thirdParty?.generalData?.tptype,
        tptypelabel: thirdParty?.generalData?.tptypelabel,

        tpkycstatuslabel: thirdParty?.generalData?.tpkycstatuslabel,
        tpkycstatus: thirdParty?.generalData?.tpkycstatus,
        tpkycdate: thirdParty?.generalData?.tpkycdate?.substring(0, 10),
        tpstatuslabel: thirdParty?.generalData?.tpstatuslabel,
        tpstatusdate: thirdParty?.generalData?.tpstatusdate?.substring(0, 10),
        tpstatuslabelgeneraldata:
          thirdParty?.generalData?.tpstatuslabel +
          ' (' +
          thirdParty?.generalData?.tpstatusdate?.substring(0, 10) +
          ')',
        tpbrokerid: thirdParty?.generalData?.tpbrokerid,
        tplegalform: thirdParty?.generalData?.tplegalform,
        tpname: thirdParty?.generalData?.tpname,
        tpsurname: thirdParty?.generalData?.tpsurname,
        tpmiddlename: thirdParty?.generalData?.tpmiddlename,
        tpmaidenname: thirdParty?.generalData?.tpmaidenname,
        tpmarketingname: thirdParty?.generalData?.tpmarketingname,
        tpmanagername: thirdParty?.generalData?.tpmanagername,
        tpmanagerposition: thirdParty?.generalData?.tpmanagerposition,
        tpactivity: thirdParty?.generalData?.tpactivity,
        tpbranchid: thirdParty?.generalData?.tpbranchid,
        mgid: thirdParty?.generalData?.mgid,
        lancode: thirdParty?.generalData?.lancode,
        countcode: thirdParty?.generalData?.countcode,
        tpcompanycreationdate: toDatePickerDate(
          thirdParty?.generalData?.tpcompanycreationdate
        ),
        tpflagvatexemption: thirdParty?.generalData?.tpflagvatexemption,
        tpvatexemtionenddate: toDatePickerDate(
          thirdParty?.generalData?.tpvatexemtionenddate
        ),
        tpfiscalid: thirdParty?.generalData?.tpfiscalid,
        tpfiscalcity: thirdParty?.generalData?.tpfiscalcity,
        tptaxid: thirdParty?.generalData?.tptaxid,
        tpsalutationcode: thirdParty?.generalData?.tpsalutationcode,
        tpgender: thirdParty?.generalData?.tpgender,
        tpbirthdate: toDatePickerDate(thirdParty?.generalData?.tpbirthdate),
        tpbirthcity: thirdParty?.generalData?.tpbirthcity,
        tpbirthcountry: thirdParty?.generalData?.tpbirthcountry,
        tpprofession: thirdParty?.generalData?.tpprofession,
        tpidentitycardtype: thirdParty?.generalData?.tpidentitycardtype,
        tpidentitycardid: thirdParty?.generalData?.tpidentitycardid,
        tpmaritalstatus: thirdParty?.generalData?.tpmaritalstatus,
        tpnbofchildren: thirdParty?.generalData?.tpnbofchildren,
        tpworkingctdate: toDatePickerDate(
          thirdParty?.generalData?.tpworkingctdate
        ),
        tpworkingcttype: thirdParty?.generalData?.tpworkingcttype,
        tporigin: thirdParty?.generalData?.tporigin,
        tpspecialtag: thirdParty?.generalData?.tpspecialtag,

        parentCompany: {
          tpid: thirdParty?.generalData?.tpparentcompanyid,
          tpname: thirdParty?.generalData?.tpparentcompanyidname,
          tpreference: thirdParty?.generalData?.tpparentcompanyidreference,
        },
        tptradingid: thirdParty?.generalData?.tptradingid,
        tpcompanyid: thirdParty?.generalData?.tpcompanyid,

        tpparentcompanyidreference:
          thirdParty?.generalData?.tpparentcompanyidreference,
        tpparentcompanyidname: thirdParty?.generalData?.tpparentcompanyidname,
        tpcapital: thirdParty?.generalData?.tpcapital,
        tpcapitalholding: Number(thirdParty?.generalData?.tpcapitalholding),
        tppoliticallyexposedperson:
          thirdParty?.generalData?.tppoliticallyexposedperson,
        tpantimoneylaunder: thirdParty?.generalData?.tpantimoneylaunder,
        tpmainadrstreet1: thirdParty?.address?.tpmainadrstreet1,
        tpmainadrstreet2: thirdParty?.address?.tpmainadrstreet2,
        tpmainadrcity: thirdParty?.address?.tpmainadrcity,
        tpmainadrzipcode: thirdParty?.address?.tpmainadrzipcode,
        tpmainadrregion: thirdParty?.address?.tpmainadrregion,
        tpmainadrregionglobale: thirdParty?.address?.tpmainadrregionglobale,
        tpmainadrcountry: thirdParty?.address?.tpmainadrcountry,
        tpsecadrstreet1: thirdParty?.address?.tpsecadrstreet1,
        tpsecadrstreet2: thirdParty?.address?.tpsecadrstreet2,
        tpsecadrcity: thirdParty?.address?.tpsecadrcity,
        tpsecadrzipcode: thirdParty?.address?.tpsecadrzipcode,
        tpsecadrregion: thirdParty?.address?.tpsecadrregion,
        tpsecadrcountry: thirdParty?.address?.tpsecadrcountry,
        bkaccountkeymain: thirdParty?.bankAccount?.bkaccountkey,
        bkaccountnummain: thirdParty?.bankAccount?.bkaccountnum,
        bkbranchcodemain: thirdParty?.bankAccount?.bkbranchcode,
        bkcodemain: thirdParty?.bankAccount?.bkcode,
        bktypemain: thirdParty?.bankAccount?.bktype,
        tpibanmain: thirdParty?.bankAccount?.tpiban,
        tpbicmain: thirdParty?.bankAccount?.tpbic,
        tpbanknamemain: thirdParty?.bankAccount?.tpbankname,
        tpcbtype: thirdParty?.bankAccount?.tpcbtype,
        tpcbnummain: thirdParty?.bankAccount?.tpcbnum,
        tpcbdatemain: thirdParty?.bankAccount?.tpcbdate,
        tpcbkeymain: thirdParty?.bankAccount?.tpcbkey,
        tpcbnamemain: thirdParty?.bankAccount?.tpcbname,
        tptel1: thirdParty?.contact?.tptel1,
        tptelmobile1: thirdParty?.contact?.tptelmobile1,
        tpemail1: thirdParty?.contact?.tpemail1,
        tpcontactname1: thirdParty?.contact?.tpcontactname1,
        tpcontactposition1: thirdParty?.contact?.tpcontactposition1,
        tptel2: thirdParty?.contact?.tptel2,
        tptelmobile2: thirdParty?.contact?.tptelmobile2,
        tpemail2: thirdParty?.contact?.tpemail2,
        tpcontactname2: thirdParty?.contact?.tpcontactname2,
        tpcontactposition2: thirdParty?.contact?.tpcontactposition2,
        tpsaleuserid: thirdParty?.correspondent?.tpsaleuserid,
        tpsaleusername: thirdParty?.correspondent?.tpsaleusername,
        tpsaleuserdate: thirdParty?.correspondent?.tpsaleuserdate?.substring(
          0,
          10
        ),
        tpriskuserid: thirdParty?.correspondent?.tpriskuserid,
        tpriskusername: thirdParty?.correspondent?.tpriskusername,
        tpriskuserdate: thirdParty?.correspondent?.tpriskuserdate?.substring(
          0,
          10
        ),
        tpbouserid: thirdParty?.correspondent?.tpbouserid,
        tpbousername: thirdParty?.correspondent?.tpbousername,
        tpbouserdate: thirdParty?.correspondent?.tpbouserdate?.substring(0, 10),
        tprecuserid: thirdParty?.correspondent?.tprecuserid,
        tprecusername: thirdParty?.correspondent?.tprecusername,
        tprecuserdate: thirdParty?.correspondent?.tprecuserdate?.substring(
          0,
          10
        ),
        tplpuserid: thirdParty?.correspondent?.tplpuserid,
        tplpusername: thirdParty?.correspondent?.tplpusername,
        tplpuserdate: thirdParty?.correspondent?.tplpuserdate?.substring(0, 10),
        tpemployer: thirdParty?.income?.tpemployer,
        tpemployeraddress: thirdParty?.income?.tpemployeraddress,
        tpemloyertel: thirdParty?.income?.tpemloyertel,
        tpmonthlyincome: thirdParty?.income?.tpmonthlyincome,
        tpothersincome: thirdParty?.income?.tpothersincome,
        tpfamilybenefits: thirdParty?.income?.tpfamilybenefits,
        tpothersexpense: thirdParty.income?.tpothersexpense,
        tpotherloan: thirdParty?.income?.tpotherloan,
        tpflagclient: thirdParty?.role?.tpflagclient,
        tpflagsupplier: thirdParty?.role?.tpflagsupplier,
        tpflagguarantor: thirdParty?.role?.tpflagguarantor,
        tproleother: thirdParty?.role?.tproleother,
        tppaymodein: thirdParty?.role?.tppaymodein,
        tppaydelayin: thirdParty?.role?.tppaydelayin,
        tppaymodeout: thirdParty?.role?.tppaymodeout,
        tppaydelayout: thirdParty?.role?.tppaydelayout,
        tplateinterestformula: thirdParty?.role?.tplateinterestformula,
        tpblocklateinterestinvoicing:
          thirdParty.role?.tpblocklateinterestinvoicing,
        tpreminderfeesformula: thirdParty?.role?.tpreminderfeesformula,
        tpblockreminderfeesinvoicing:
          thirdParty?.role?.tpblockreminderfeesinvoicing,
        tpblockrejectionfeesinvoicing:
          thirdParty?.role?.tpblockrejectionfeesinvoicing,
        tprejectionfeesformula: thirdParty?.role?.tprejectionfeesformula,

        spname: thirdParty?.spouse?.spname,
        spsurname: thirdParty?.spouse?.spsurname,
        spgender: thirdParty?.spouse?.spgender,
        spbirthdate: toDatePickerDate(thirdParty?.spouse?.spbirthdate),
        spbirthcity: thirdParty?.spouse?.spbirthcity,
        spbirthcountry: thirdParty?.spouse?.spbirthcountry,
        spmaidenname: thirdParty?.spouse?.spmaidenname,

        spsalutationcode: thirdParty?.spouse?.spsalutationcode,
        spfiscalid: thirdParty?.spouse?.spfiscalid,
        spprofession: thirdParty?.spouse?.spprofession,
        spidentitycardtype: thirdParty?.spouse?.spidentitycardtype,
        spidentitycardid: thirdParty?.spouse?.spidentitycardid,
        spemployer: thirdParty?.spouse?.spemployer,
        spemployeraddress: thirdParty?.spouse?.spemployeraddress,
        spemloyertel: thirdParty?.spouse?.spemloyertel,
        spmonthlyincome: thirdParty?.spouse?.spmonthlyincome,
        spothersincome: thirdParty?.spouse?.spothersincome,
        spothersexpense: thirdParty?.spouse?.spothersexpense,
        spotherloan: thirdParty?.spouse?.spotherloan,
        tpsalestatuslabel: thirdParty?.status?.tpsalestatuslabel,
        tpsalestatusdate: thirdParty?.status?.tpsalestatusdate?.substring(
          0,
          10
        ),
        tpriskstatuslabel: thirdParty?.status?.tpriskstatuslabel,
        tpriskstatusdate: thirdParty?.status?.tpriskstatusdate?.substring(
          0,
          10
        ),
      });
      if (!isNil(thirdParty?.entityAddAttributList)) {
        let test = {};

        thirdParty?.entityAddAttributList?.forEach(
          (att: ViewEntityAddAttributeResponse) => {
            let value: any;

            if (att.attdatatype === 'STRING') {
              value = att.attstringvalue;
            } else if (att.attdatatype === 'LONG') {
              value = att.attnumericvalue;
            } else if (att.attdatatype === 'DOUBLE') {
              value = att.attnumericvalue;
            } else if (att.attdatatype === 'BOOLEAN') {
              value = att.attbooleanvalue;
            } else if (att.attdatatype === 'TEXT') {
              value = att.atttextvalue;
            } else if (att.attdatatype === 'DATE') {
              if (moment(att.attstringvalue, false).isValid()) {
                value = moment(att.attstringvalue, false);
              } else {
                value = null;
              }
            }

            let obj = { [att.attcode]: value };
            test = { ...test, ...obj };
          }
        );
        form.setFieldsValue({ entityAddAttributList: test });
      }
    }
  }, [thirdParty, form]);

  const prepareThirdPartyRequest = (values: any): ThirdPartyRequest => {
    return {
      additionalInfo: {
        tpparentcompanyid: values?.tpparentcompanyid,
        tpparentcompanyname: values?.tpparentcompanyname,
        tpfree1: values?.tpfree1,
        tpfree2: values?.tpfree2,
        tpfree3: values?.tpfree3,
        tpfree4: values?.tpfree4,
        tpfree5: values?.tpfree5,
        tpdescription: values?.tpdescription,
      },
      address: {
        tpmainadrstreet1: values?.tpmainadrstreet1,
        tpmainadrstreet2: values?.tpmainadrstreet2,
        tpmainadrcity: values?.tpmainadrcity,
        tpmainadrzipcode: values?.tpmainadrzipcode,
        tpmainadrregion: values?.tpmainadrregion,
        tpmainadrregionglobale: values?.tpmainadrregionglobale,
        tpmainadrcountry: values?.tpmainadrcountry,
        tpsecadrstreet1: values?.tpsecadrstreet1,
        tpsecadrstreet2: values?.tpsecadrstreet2,
        tpsecadrcity: values?.tpsecadrcity,
        tpsecadrzipcode: values?.tpsecadrzipcode,
        tpsecadrregion: values?.tpsecadrregion,
        tpsecadrcountry: values?.tpsecadrcountry,
      },
      bankAccount: {
        bkaccountkey: values?.bkaccountkeymain,
        bkaccountnum: values?.bkaccountnummain,
        bkbranchcode: values?.bkbranchcodemain,
        bkcode: values?.bkcodemain
          ? values?.bkcodemain
          : form.getFieldValue('bkcodemain'),
        bktype: values?.bktype,
        countcode: values?.countcode,
        tpbkid: values?.tpbkid,
        currcode: values?.currcode,
        tpiban: values?.tpibanmain,
        tpbic: values?.tpbicmain,
        tpbankname: values?.tpbanknamemain,
        tpcbtype: values?.tpcbtype,
        tpcbnum: values?.tpcbnum,
        tpcbdate: values?.tpcbdate,
        tpcbkey: values?.tpcbkey,
        tpcbname: values?.tpcbname,
      },
      contact: {
        tptel1: values?.tptel1,
        tptelmobile1: values?.tptelmobile1,
        tpemail1: values?.tpemail1,
        tpcontactname1: values?.tpcontactname1,
        tpcontactposition1: values?.tpcontactposition1,
        tptel2: values?.tptel2,
        tptelmobile2: values?.tptelmobile2,
        tpemail2: values?.tpemail2,
        tpcontactname2: values?.tpcontactname2,
        tpcontactposition2: values?.tpcontactposition2,
      },
      generalData: {
        tpcompanyid: values?.tpcompanyid,
        tptradingid: values?.tptradingid,
        currcode: values?.currcode,
        tpid: values?.tpid,
        tptype: values?.tptype,
        tpbrokerid: values?.tpbrokerid,
        tplegalform: values?.tplegalform,
        tpname: values?.tpname,
        tpsurname: values?.tpsurname,
        tpmiddlename: values?.tpmiddlename,
        tpmaidenname: values?.tpmaidenname,
        tpflagvatexemption: values?.tpflagvatexemption,
        tpvatexemtionenddate: values?.tpvatexemtionenddate,
        tpmarketingname: values?.tpmarketingname,
        tpmanagername: values?.tpmanagername,
        tpmanagerposition: values?.tpmanagerposition,
        tpactivity: values?.tpactivity,
        tpbranchid: values?.tpbranchid,
        lancode: values?.lancode,
        countcode: values?.countcode,
        tpcompanycreationdate: values?.tpcompanycreationdate,
        tpfiscalid: values?.tpfiscalid,
        tpfiscalcity: values?.tpfiscalcity,
        tptaxid: values?.tptaxid,
        tpsalutationcode: values?.tpsalutationcode,
        tpgender: values?.tpgender,
        tpbirthdate: values?.tpbirthdate,
        tpbirthcity: values?.tpbirthcity,
        tpbirthcountry: values?.tpbirthcountry,
        tpprofession: values?.tpprofession,
        tpidentitycardtype: values?.tpidentitycardtype,
        tpidentitycardid: values?.tpidentitycardid,
        tpmaritalstatus: values?.tpmaritalstatus,
        tpnbofchildren: values?.tpnbofchildren,
        tpworkingctdate: dateToString(values?.tpworkingctdate),
        tpworkingcttype: values?.tpworkingcttype,
        tpcapital: values?.tpcapital,
        tpcapitalholding: values?.tpcapitalholding,
        tpkycstatus: values?.tpkycstatus,
        tppoliticallyexposedperson: values?.tppoliticallyexposedperson,
        tpantimoneylaunder: values?.tpantimoneylaunder,
        tporigin: values?.tporigin,
        tpspecialtag: values?.tpspecialtag,
        tpparentcompanyid: values?.parentCompany?.tpid,
        last_action: Number(getId())
          ? wizData?.taskidUpdate
          : wizData?.taskidCreate,
        tpflagresident: values?.tpflagresident,
        tpcategory: values?.tpcategory,
        tpcompanysize: values?.tpcompanysize,
        tprevenue: values?.tprevenue,
        tprevenuereferenceyear: values?.tprevenuereferenceyear,
        tpidentitycardcountry: values?.tpidentitycardcountry,
        tpidentitycardexpirationdate: dateToString(
          values?.tpidentitycardexpirationdate
        ),
        tpactivitysector: values?.tpactivitysector,
      }
    };
  };

  const onFinish = (e: any) => {
    form
      .validateFields()
      .then((values) => {
        const tpdData = prepareThirdPartyRequest(values);

        let generalData = {
          ...tpdData?.generalData,
          tpbirthdate: dateToString(tpdData?.generalData?.tpbirthdate),
        };

        const dataSave = {
          ...tpdData,
          generalData: generalData,
        };
        setLoadingBtn(true);
        if (thirdParty) {
          updateThirdParty({
            ThirdPartyRequest: dataSave,
            tpid: Number(id),
          })
            .then((res) => {
              setLoadingBtn(false);
              if (res.code === '200') {
                notification.success({
                  message: 'ThirdParty updated successfully ',
                });
                //history.push(`/third-party/${res.data.generalData.tpid}/${phase}`);
                thirdParty = res.data;
                refetch();
              } else {
                setLoadingBtn(false);
                notification.warning({
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              setLoadingBtn(false);
            });
        } else {
          createThirdParty({ ThirdPartyRequest: dataSave })
            .then((res) => {
              if (res.code === '200') {
                notification.success({
                  message: 'ThirdParty created successfully  ',
                });
                setLoadingBtn(false);
                onSelect && onSelect(res.data);
                history.push(
                  `/third-party/${res.data.generalData.tpid}/TP/${wizData?.taskidDisplay}`
                );
                setLoadingBtn(false);
              } else {
                notification.warning({
                  message: res.message,
                  description: res.description,
                });
                isModal && form.resetFields();
              }
            })
            .catch((err) => {
              setLoadingBtn(false);
            });
        }
      })
      .catch((err) => {
        setLoadingBtn(false);
      });
  };

  const { data: TpCurrentStatus, isFetching: isFetchingTpCurr } = useQuery(
    ['getTPCurrentStatusByTpid', id],
    () =>
      getTPCurrentStatusByTpid({ tpid: Number(id), type: '' }).then(
        (res) => res.list || []
      ),
    { enabled: !!id }
  );

  const { data: tpauthlist, refetch: refetchtpauth } = useQuery(
    ['getThirdPartyAuthorizationListByTpid', { tpid: Number(id) }],
    () =>
      getThirdPartyAuthorizationListByTpid({ tpid: Number(id) }).then(
        (res) => res.list || []
      ),
    { enabled: !!id }
  );

  return (
    <DF.Provider
      pagcode="tpdetailsfs"
      entity="THIRDPARTY"
      entityid={Number(id) || 0}
      additionalAttribute={{
        entity: 'THIRDPARTY',
        entitytype: tptype,
        object: 'THIRDPARTY',
      }}
    >
      <Form
        layout="horizontal"
        form={form}
        labelAlign="left"
        // initialValues={INITIAL_VALUES}
        // onFinishFailed={onFinishFailed}
        // onSubmitCapture={onFinish}
      >
        {/* <Row
          style={{
            fontSize: '14px',
            fontWeight: 'bold',
            marginBottom: 9,
          }}
          justify="end"
        >
          <Col span={!Number(id) ? 5 : 4}>
            <SaveButton
              comcode="save"
              custom={{ height: 52 }}
              loading={loadingBtn}
            />
          </Col>
        </Row> */}
        <WizardTabs
          className="sfs_style"
          entity="THIRDPARTY"
          entityid={Number(id) || undefined}
          taskid={
            taskid
              ? taskid
              : id
              ? wizData?.taskidDisplay
              : wizData?.taskidCreate
          }
          defaultTabs={[
            'tabGeneralDataSFS',
            'tabPlafondsandGradingSFS',
            'TabBkInfoSFS',
            'tabAddressSFS',
            'tabcontactsSFS',
            'AccordSFS',
          ]}
          hiddenTabs={[
            'tabGeneralData',
            'tabAddresses',
            'tabContacts',
            'tabBankAccount',
            'tabCorrespondants',
            'tabFinStatement',
            'tabIncome',
            'tabUpload',
            'tabCheckList',
            'tabSpouse',
            'tabFlows',
            'tabRoles',
            'tabRelationShipList',
            'tabProcessFollowup',
            'tabTPAuthorization',
            'tabTpRating',
            'tabStatus',
            'tabAdditionalInfo',
          ]}
          tabPosition="top"
          tabs={{
            tabGeneralDataSFS: (
              <Spin spinning={isFetching}>
                <GeneralDataSFS
                  form={form}
                  tpid={id}
                  TpCurrentStatus={TpCurrentStatus ?? []}
                  tpauthlist={tpauthlist ?? []}
                />
              </Spin>
            ),
            tabPlafondsandGradingSFS: (
              <TabPlafondsandGradingSFS
                id={Number(id)}
                tpauthlist={tpauthlist ?? []}
                data={data}
              />
            ),
            TabBkInfoSFS: (
              <TabBkInfoSFS form={form} id={Number(id)} data={data} />
            ),
            tabAddressSFS: <AddressCardSFS form={form} id={Number(id)} />,
            tabcontactsSFS: <ContactCardSFS form={form} />,
            AccordSFS: <AccordSFS form={form} tpauthlist={tpauthlist ?? []} />,
          }}
        />
      </Form>
    </DF.Provider>
  );
};

export default ThirdPartyDetailSFS;
